import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { usePaymentRequest } from "../../../../../hooks/usePaymentRequest";
import { PaymentRequestItem } from "./PaymentRequestItem";

export function PaymentIssues() {
	const { unpaidPaymentRequests } = usePaymentRequest();

	const haveIssues = unpaidPaymentRequests.length > 0;

	if (!haveIssues) {
		return null;
	}

	return (
		<>
			<div className="title-container section-separator">
				<Typography className="small-title-text bold">
					Payment Requests
				</Typography>
				<Link to="/training/payments" className="black-text underline-link">
					<Typography className="normal-text">View all</Typography>
				</Link>
			</div>
			{unpaidPaymentRequests.length > 0 && (
				<div className="payments item-separator-tiny">
					{unpaidPaymentRequests.map((unpaidPaymentRequest) => (
						<PaymentRequestItem
							paymentRequest={unpaidPaymentRequest}
							key={unpaidPaymentRequest.id}
						/>
					))}
				</div>
			)}
		</>
	);
}
